export function computeTechniqueImpact(roadwork, taskTypes) {
    const impact = roadwork?.tasks.reduce((acc, task) => {
        const taskType = taskTypes.find(taskType => taskType.code === task.taskType)
        return Math.max(taskType?.impact ?? 0, acc)
    }, 0)

    return impact
}